module.exports = __webpack_public_path__ + "media/images/corefl_advanced_search-2b7fdcc405ea9af334575faf82fe54ac.gif";